import { useState, useEffect } from "react";

const TopBar = () => {
  const [show, setShow] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const controlTopBar = () => {
    if (window.scrollY > lastScrollY && window.scrollY > 100) {
      setShow(false); // Oculta la barra
    } else {
      setShow(true); // Muestra la barra
    }
    setLastScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", controlTopBar);
    return () => {
      window.removeEventListener("scroll", controlTopBar);
    };
  }, [lastScrollY]);

  return (
    <div
      className={`fixed top-0 left-0 w-full bg-blue-600 text-white py-2 sm:py-3 px-4 text-center transition-transform duration-300 z-50 shadow-md ${
        show ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      {/* Contenedor Flex para asegurar el centrado del texto en ambas líneas en móvil */}
      <div className="flex flex-col sm:flex-row justify-center items-center text-sm sm:text-lg font-extrabold tracking-tight">
        
        {/* Primera Parte: Alerta y Exclusividad */}
        <span className="mb-0.5 sm:mb-0 sm:mr-1"> 
          ⚠️ Exclusivo para negocios que reciben 
        </span>
        
        {/* Segunda Parte: El Filtro (esto será lo que baje de línea en móvil) */}
        <span>
          +100 consultas mensuales ⚠️
        </span>

      </div>
    </div>
  );
};

export default TopBar;